export const VNCATEGORIES_SET_SELECTED_CATEGORY = 'VNCATEGORIES_SET_SELECTED_CATEGORY'
export const VNCATEGORIES_TOGGLE_FAVORITE_ITEM = 'VNCATEGORIES_TOGGLE_FAVORITE_ITEM'
export const VNCATEGORIES_ADD_FAVORITE_ITEM = 'VNCATEGORIES_ADD_FAVORITE_ITEM'
export const VNCATEGORIES_REMOVE_FAVORITE_ITEM = 'VNCATEGORIES_REMOVE_FAVORITE_ITEM'
export const VNCATEGORIES_SET_CATEGORY_SEARCH = 'VNCATEGORIES_SET_CATEGORY_SEARCH'
